import { FC, useEffect, useMemo, useState } from 'react';
import { EActiveETransfer } from '@enum';
import styles from './styles.module.scss';
import classNames from 'classnames/bind';
import { useNavigate } from 'react-router-dom';
import { routes } from '@const/routes';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import { pageAnimation } from '@const/animation';
import { useVerificationGuard } from '@hooks/helpers/useVerificationGuard';
import { useUserContext } from '@hooks/context/useUserContext';
import useResponsive from '@hooks/helpers/useResponsive';
import { useNavigationContext } from '@hooks/context/useNavigationContext';
import CreateGiftCardSection from '@sections/gift_cards/create_gift_card';

const cx = classNames.bind(styles);

interface IProps {
    activeTab?: EActiveETransfer;
}

const CreateGiftCardlayout: FC<IProps> = ({ activeTab }) => {
    const navigate = useNavigate();
    const { t } = useTranslation('send_and_request');
    const { verifiedAction } = useVerificationGuard();
    const [currentTab, setCurrentTab] = useState<EActiveETransfer>();
    const { user } = useUserContext();
    const { isTablet, isMobile } = useResponsive();
    const isLessThenTablet = useMemo(() => isTablet || isMobile, [isTablet, isMobile]);
    const { handleBack } = useNavigationContext();

    const contentStyle = useMemo(
        () => cx([styles.content_wrapper, { isOpen: !!currentTab }]),
        [currentTab]
    );

    useEffect(() => {
        if (activeTab) {
            verifiedAction(
                () => {
                    setCurrentTab(activeTab);
                },
                () => {
                    setCurrentTab(undefined);
                    navigate(routes.send_and_request);
                }
            );
        } else {
            setCurrentTab(undefined);
        }
    }, [activeTab, user]);

    return (
        <motion.div {...pageAnimation} className={styles.wrapper}>
            <div className={contentStyle}>
                <div className={styles.content}>
                    <CreateGiftCardSection />
                </div>
            </div>
        </motion.div>
    );
};

export default CreateGiftCardlayout;
